export default {
    baseStyle: {
        _focus: {
            clip: null,
            width: null,
            height: null
        },
        _focusVisible: {
            clip: 'auto',
            width: 'auto',
            height: 'auto'
        }
    }
}
